import { saveDiscoveryRulesGridState as saveDiscoveryRulesGridStateDiagram  } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Props = ApiMethodBase & {
    columnState: [];
};

export const saveDiscoveryRulesGridState = ({
    columnState,
}: Props) => {
    saveDiscoveryRulesGridStateDiagram(columnState);
};
